import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Empty, Spin } from "antd";
import { StyledBlogDetail } from "./styles";
import TopBar from "../Landing/Topbar";
import FooterSection from "../Landing/FooterSection";
import httpClient from "../../../api/httpClient";
import { FILE_BASE_URL } from "../../../config";

const BlogDetail = () => {
  const { id } = useParams();

  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getBlog = async () => {
      try {
        setLoading(true);

        const { data } = await httpClient.get(`blogs`, {
          params: { id },
        });

        setBlog(data?.[0] || null);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };
    getBlog();
  }, []);

  return (
    <StyledBlogDetail>
      <TopBar />

      <div className="blog-detail">
        {loading ? (
          <div className="flex-center loading">
            <Spin />
          </div>
        ) : blog ? (
          <>
            <img
              className="detail-image"
              src={`${FILE_BASE_URL}${blog.image}`}
              alt={blog.title}
            />
            <h1 className="detail-title">{blog.title}</h1>
            <iframe
              className="detail-description"
              src={`${FILE_BASE_URL}${blog.description}`}
              title={blog.title}
              width="100%"
              height="1000"
              style={{
                border: "none",
              }}
            />
          </>
        ) : (
          <div className="flex-center not-found">
            <Empty description="Blog not found" />
          </div>
        )}
      </div>
      <FooterSection />
    </StyledBlogDetail>
  );
};

export default BlogDetail;
